import ProjectFlowGraphs from './ProjectFlowGraphs'
import ProjectFlowGraphsTestHarness from './ProjectFlowGraphsTestHarness'

ProjectFlowGraphs.TestHarness = ProjectFlowGraphsTestHarness
export default ProjectFlowGraphs
